import { Injectable } from "@angular/core";
import QRCode from "qrcode";
import { TenantService } from "./tenant.service";

@Injectable({
    providedIn: "root",
})
export class QRCodeService {
    constructor(private tenantService: TenantService) {}

    generateQRCode(secretKey: string): Promise<string> {
        const tenantKey = this.tenantService.tenantInfo().tenantKey;
        const otpAuthUrl = `otpauth://totp/Mentor:${tenantKey}?secret=${secretKey}&issuer=Mentor`;
        return QRCode.toDataURL(otpAuthUrl);
    }
}
